// ISO 3166-1 alpha-2
enum RegionCode {
  ID = 'ID',
  IN = 'IN',
  MY = 'MY',
  PH = 'PH',
  SG = 'SG',
  TH = 'TH',
  VN = 'VN',
  NONE = ''
}

export default RegionCode;
